import { ViewContainerRef } from '@angular/core';
import { Button } from 'primeng/button';
import { Message } from 'primeng/message';
import { Table } from 'primeng/table';

export const loadPrimeNgComponentStyles = (vcr: ViewContainerRef) => {
	[Button, Message, Table].forEach(c => {
		const component = vcr.createComponent<any>(c);
		component.instance
			._loadStyles();
		component.instance._themeChangeListener(() => setTimeout(() => component.destroy(), 0));
	});
};